const choices = [
    { id: 'coach', label: 'Fernbus' },
    { id: 'minibus', label: 'Minibus' },
    { id: 'own_car', label: 'Eigener PKW' },
    { id: 'train', label: 'Zug' },
    { id: 'airplane', label: 'Flugzeug' },
    { id: 'other', label: 'Sonstiges' },
];
module.exports = choices;
